/*jshint esversion: 9 */
import React from "react";
import { Fragment } from "react";
import { connect } from "react-redux";
// import { withStyles } from "@material-ui/core/styles";
import { doLog, hasValue, notNull, updateObject } from "../../shared/utility";

import * as actions from "../../store/actions/index";
import Button from "@material-ui/core/Button";
import classes from "../CrimeSubmission.css";
import confirm from "../../shared/confirm";
import Grid from "@material-ui/core/Grid";
import Form from "../../components/UI/Form/Form";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import ManageRequiredFields from "./ManageRequiredFields";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";

const mappedSelectPropFields = [];

const mappedTextPropFields = [
  "CONFIRMINGQUESTION",
  "DEFINITION",
  "DESCRIPTION",
  "EXAMPLES",
  "INCIDENTTYPE",
  "ORI",
  "REQUIRENAMEINFO",
  "REQUIREPROPERTYINFO",
  "REQUIRETOWINFO",
  "REQUIREVEHICLEINFO",
  "PERMISSIONNAME",
  "ACTIVEFLAG",
];
// If fields are added to this list, also update getMappedPropValue and putMappedPropValue functions

// const styles = (theme) => ({
//   root: {
//     flexGrow: 1,
//     backgroundColor: theme.palette.background.paper,
//   },
//   textField: {
//     width: 250,
//   },
//   dense: {
//     marginTop: 19,
//   },
//   spacing: 1,
// });

const gridSpacing = 0; //0 or 8 or 16 or 24 or 32 or 40
const quote = '"';
const singleQuote = "'";

class ManageIncidentType extends Form {
  state = {
    searching: false,
    editMode: true,
    timeoutSecs: 10,
    requiredFieldErrMsg: "Required fields are needed",
    requiredFieldInProcess: false,
    requiredDefaultFieldInProcess: false,
    keyFieldValue: null,
    sectionName: "ManageIncidentType",
    //
    itemChanged: false,
    item: null,
    actionEdit: false,
    actionAdd: false,
    //
    addAnother: false,
    //
    mappedSelectPropFields: mappedSelectPropFields,
    mappedTextPropFields: mappedTextPropFields,
    //
    CONFIRMINGQUESTION: {
      inputType: "text",
      value: "",
      label: "Confirming Question",
      maxSize: 100,
    },
    DEFINITION: {
      inputType: "text",
      value: "",
      multiline: true,
      rows: 4,
      label: "Definition",
    },
    DESCRIPTION: {
      inputType: "text",
      value: "",
      label: "Description",
      maxSize: 80,
      validation: { required: true },
    },
    EXAMPLES: {
      inputType: "text",
      value: "",
      multiline: true,
      rows: 4,
      label: "Examples",
    },
    INCIDENTTYPE: {
      inputType: "text",
      value: "",
      label: "Incident Type",
      maxSize: 12,
      upperOnly: true,
      validation: { required: true },
      keyField: true,
    },
    ORI: {
      inputType: "text",
      value: "",
      label: "ORI",
      maxSize: 9,
      upperOnly: true,
      validation: { required: true },
      disabled: true,
    },
    REQUIRENAMEINFO: {
      inputType: "checkbox",
      value: "",
      label: "Require Person Info",
      checkedValue: "Y",
      uncheckedValue: "N",
    },
    REQUIREPROPERTYINFO: {
      inputType: "checkbox",
      value: "",
      label: "Require Property Info",
      checkedValue: "Y",
      uncheckedValue: "N",
    },
    REQUIRETOWINFO: {
      inputType: "checkbox",
      value: "",
      label: "Require Towing Info",
      checkedValue: "Y",
      uncheckedValue: "N",
    },
    REQUIREVEHICLEINFO: {
      inputType: "checkbox",
      value: "",
      label: "Require Vehicle Info",
      checkedValue: "Y",
      uncheckedValue: "N",
    },
    PERMISSIONNAME: {
      inputType: "text",
      value: "",
      label: "Permission Code (Optional)",
      maxSize: 30,
    },
    ACTIVEFLAG: {
      inputType: "checkbox",
      value: "",
      label: "Active",
      checkedValue: "Y",
      uncheckedValue: "N",
    },
    //
    selectIncidentType: {
      inputType: "datagrid",
      value: null,
      label: null,
      // validation: { required: true },
      useSearch: false,
      searchText: "",
      gridColumns: [],
      gridDefaultRows: [],
      gridRows: [],
      selectedRows: [-1],
      rowCount: 4,
      onGridRowClick: (fieldName) => (param, event) => {
        this.handleRowClick(fieldName, param, event);
      },
      onGridCheckBoxClick: (fieldName) => (newSelectionModel) => {
        this.handleIncidentTypeCheckbox(fieldName, newSelectionModel);
      },
    },
    //
  };

  componentDidMount() {
    if (doLog())
      console.log("[ManageIncidentType] componentDidMount state:", this.state);
    if (doLog())
      console.log("[ManageIncidentType] componentDidMount props:", this.props);
    this.setState({
      ORI: updateObject(this.state.ORI, {
        value: this.props.ori,
      }),
    });
  }

  componentDidUpdate() {
    if (doLog())
      console.log("[ManageIncidentType] componentDidUpdate state:", this.state);
    if (doLog())
      console.log("[ManageIncidentType] componentDidUpdate props:", this.props);
    if (
      hasValue(this.state.item) &&
      this.props.requiredFieldList === null &&
      !this.state.requiredFieldInProcess
    ) {
      this.props.onFetchRequiredFieldList(
        this.props.ori,
        this.props.token,
        this.state.item.INCIDENTTYPE
      );
      this.setState({ requiredFieldInProcess: true });
    } else if (this.props.defaultRequiredFieldList === null) {
      this.props.onFetchDefaultRequiredFieldList(this.props.token);
    } else if (
      (!hasValue(this.props.result) ||
        !hasValue(this.props.result.RESULT) ||
        !hasValue(this.props.result.RESULT.CITIZENINCIDENTTYPE)) &&
      this.props.transDesc !== "incidentTypeList"
    ) {
      if (!this.state.searching) {
        const transactionType =
          '<CIDDB><QUERY TABLE="CitizenIncidentType"' +
          ' WHERE="ORI=' +
          singleQuote +
          this.props.ori +
          singleQuote +
          quote +
          ' LIMIT="9999" OPERATORID="-1"><FIELD_LIST>ALL</FIELD_LIST><ORDER_BY><DESCRIPTION/></ORDER_BY></QUERY></CIDDB>';
        const data = {};
        const request = {
          transactionType,
          data,
        };
        this.setState({ searching: true });
        this.props.onRunTransaction(
          request,
          this.props.token,
          "incidentTypeList"
        );
      }
    }

    if (
      this.state.requiredFieldInProcess &&
      this.props.requiredFieldList !== null
    ) {
      this.setState({ requiredFieldInProcess: false });
    }

    if (
      this.state.requiredDefaultFieldInProcess &&
      this.props.requiredDefaultFieldList !== null
    ) {
      this.setState({ requiredDefaultFieldInProcess: false });
    }

    if (
      this.state.searching &&
      this.props.error === null &&
      hasValue(this.props.result)
    ) {
      if (doLog())
        console.log(
          "[ManageIncidentType] componentDidUpdate result:",
          this.props.result
        );
      if (doLog())
        console.log(
          "[ManageIncidentType] componentDidUpdate transDesc:",
          this.props.transDesc
        );
      this.setState({ searching: false });
      const resultMsg = this.props.result[0];
      if (
        (this.props.transDesc === "incidentTypeWrite" ||
          this.props.transDesc === "incidentTypeDelete") &&
        resultMsg === "Complete"
      ) {
        if (doLog())
          console.log(
            "[ManageIncidentType] componentDidUpdate incidentTypeWrite Complete found"
          );
        this.props.onClearTransDesc();
        this.props.onClearTransactionResult();
        this.props.onClearRequiredFieldList();
        this.props.onSetRequiredFieldArray([]);

        if (this.state.addAnother) {
          this.handleAddButton();
        } else {
          this.setState({
            actionEdit: false,
            actionAdd: false,
            addAnother: false,
          });
        }
      }
    } else if (hasValue(this.state.item) && this.state.itemChanged) {
      this.copyFieldValuesToState();
      this.setState({ itemChanged: false });
    } else {
      let array = null;
      if (
        hasValue(this.props.result !== null) &&
        hasValue(this.props.result.RESULT) &&
        hasValue(this.props.result.RESULT.CITIZENINCIDENTTYPE) &&
        this.props.transDesc === "incidentTypeList"
      ) {
        array = this.props.result.RESULT.CITIZENINCIDENTTYPE;
      }

      if (doLog())
        console.log("[ManageIncidentType] componentDidUpdate array:", array);
      if (doLog())
        console.log("[ManageIncidentType] componentDidUpdate gridDefaultRows.length:", this.state.selectIncidentType.gridDefaultRows.length);
      if (
        array !== null &&
        this.state.selectIncidentType.gridDefaultRows.length === 0
      ) {
        this.loadGridRows(array);
      }
    }
  }

  copyFieldValuesToState() {
    if (doLog())
      console.log(
        "[ManageIncidentType]copyFieldValuesToState item:",
        this.state.item
      );
    if (this.state.item !== null) {
      const item = this.state.item;
      for (let field in this.state.mappedTextPropFields) {
        const fieldName = this.state.mappedTextPropFields[field];
        // if (doLog()) console.log(
        //   "[ManageIncidentType]copyFieldValuesToState text field:",
        //   fieldName
        // );
        const newValue = notNull(item[fieldName]);
        // if (doLog()) console.log(
        //   "[ManageIncidentType]copyFieldValuesToState text newValue:",
        //   newValue
        // );
        this.setState({
          [fieldName]: updateObject(this.state[fieldName], {
            value: newValue,
          }),
        });
        if (this.state[fieldName].keyField === true) {
          this.setState({ keyFieldValue: newValue });
        }
      }

      for (let field in this.state.mappedSelectPropFields) {
        const fieldName = this.state.mappedSelectPropFields[field];
        // if (doLog()) console.log(
        //   "[ManageIncidentType]copyFieldValuesToState select field:",
        //   fieldName
        // );
        this.setState({
          [fieldName]: updateObject(this.state[fieldName], {
            value: notNull(item[fieldName]),
          }),
        });
      }
    }
  }

  handleAddButton = () => {
    if (doLog()) console.log("[ManageIncidentType] handleAddButton");
    this.setState({
      actionEdit: false,
      actionAdd: true,
      ORI: updateObject(this.state.ORI, {
        value: this.props.ori,
      }),
      INCIDENTTYPE: updateObject(this.state.INCIDENTTYPE, {
        value: "",
      }),
      DESCRIPTION: updateObject(this.state.DESCRIPTION, {
        value: "",
      }),
      DEFINITION: updateObject(this.state.DEFINITION, {
        value: "",
      }),
      EXAMPLES: updateObject(this.state.EXAMPLES, {
        value: "",
      }),
      REQUIRENAMEINFO: updateObject(this.state.REQUIRENAMEINFO, {
        value: "N",
      }),
      REQUIREPROPERTYINFO: updateObject(this.state.REQUIREPROPERTYINFO, {
        value: "N",
      }),
      REQUIREVEHICLEINFO: updateObject(this.state.REQUIREVEHICLEINFO, {
        value: "N",
      }),
      REQUIRETOWINFO: updateObject(this.state.REQUIRETOWINFO, {
        value: "N",
      }),
      PERMISSIONNAME: updateObject(this.state.PERMISSIONNAME, {
        value: "",
      }),
      ACTIVEFLAG: updateObject(this.state.ACTIVEFLAG, {
        value: "Y",
      }),
    });
  };

  handleCancelButton = () => {
    if (doLog()) console.log("[ManageIncidentType] handleCancelButton");
    this.setState({ actionEdit: false, actionAdd: false });
  };

  handleDeleteButton = () => {
    if (doLog()) console.log("[ManageIncidentType] handleDeleteButton");
    confirm("Are you sure you want to delete?", {
      title: "Delete Incident Type",
      okLabel: "Yes",
    }).then(
      (result) => {
        if (doLog()) console.log("delete confirmed");
        const transactionType = "CitizenIncidentTypeDelete";
        const data = {
          ori: this.state.ORI.value,
          incidentType: this.state.keyFieldValue,
        };
        const request = {
          transactionType,
          data,
        };

        if (doLog())
          console.log("[ManageAgency] handleDeleteButton request:", request);
        this.setState({ searching: true });
        this.props.onRunTransaction(
          request,
          this.props.token,
          "incidentTypeDelete"
        );
      },
      (result) => {
        if (doLog()) console.log("delete cancelled");
        if (doLog()) console.log(result);
      }
    );
  };

  handleIncidentTypeCheckbox = (fieldName, newSelectionModel) => {
    if (doLog())
      console.log(
        "[ManageIncidentType] handleIncidentTypeCheckbox newSelectionModel:",
        newSelectionModel
      );
    if (doLog())
      console.log(
        "[ManageIncidentType] handleIncidentTypeCheckbox props:",
        this.props
      );
    if (newSelectionModel != null && newSelectionModel[1] != null) {
      const index = newSelectionModel[1];
      if (doLog())
        console.log(
          "[ManageIncidentType] handleIncidentTypeCheckbox index:",
          index
        );
      let selectedRow = -1;
      if (hasValue(this.state.selectIncidentType.selectedRows)) {
        selectedRow = this.state.selectIncidentType.selectedRows[0];
      }
      if (doLog())
        console.log(
          "[ManageIncidentType] handleIncidentTypeCheckbox selectedRow:" +
            selectedRow
        );
      if (selectedRow !== index && index >= 0) {
        const array = this.props.result.RESULT.CITIZENINCIDENTTYPE;
        const item = array[index];
        this.setState({
          [fieldName]: updateObject(this.state[fieldName], {
            value: item.INCIDENTTYPE,
            selectedRows: [index],
          }),
          item: item,
          itemChanged: true,
          actionEdit: true,
          actionAdd: false,
        });
        this.props.onClearRequiredFieldList();
        this.props.onSetRequiredFieldArray([]);
      }
    }
  };

  handleRowClick = (fieldName, param, event) => {
    if (doLog())
      console.log("[ManageIncidentType] handleRowClick fieldName:", fieldName);
    if (doLog())
      console.log("[ManageIncidentType] handleRowClick param:", param);
    if (doLog())
      console.log("[ManageIncidentType] handleRowClick event:", event);
    if (param != null && param.row != null) {
      const array = this.props.result.RESULT.CITIZENINCIDENTTYPE;
      const row = param.row;
      const item = array[row.id];
      if (doLog())
        console.log("[ManageIncidentType] handleRowClick item:", item);
      this.setState({
        item: item,
        itemChanged: true,
        actionEdit: true,
        actionAdd: false,
      });
      this.setState({
        [fieldName]: updateObject(this.state[fieldName], {
          value: item.INCIDENTTYPE,
        }),
      });
      this.props.onClearRequiredFieldList();
      this.props.onSetRequiredFieldArray([]);
    }
  };

  handleSubmitAddButton = () => {
    if (doLog()) console.log("[ManageIncidentType] handleSubmitAddButton");
    const noAdd = false;
    this.issueSubmit(noAdd);
    this.setState({ actionEdit: false, actionAdd: true, addAnother: true });
  };

  handleSubmitButton = () => {
    if (doLog())
      console.log(
        "[ManageIncidentType] handleSubmitButton add:" + this.state.actionAdd
      );
    const doAdd = this.state.actionAdd;
    this.issueSubmit(doAdd);
    this.setState({ actionEdit: false, actionAdd: false, addAnother: false });
  };

  handleUserTypeButtonsChange = (event) => {
    const typeSelected = event.target.value;

    if (typeSelected.value === -1)
      this.setState({
        STATUS: updateObject(this.state.REQUIRETOWINFO, {
          value: "N",
        }),
      });
    else {
      this.setState({
        STATUS: updateObject(this.state.REQUIRETOWINFO, {
          value: typeSelected,
        }),
      });
    }

    console.log(
      `[ReviewDetails] handleUserTypeButtonsChange typeSelected:`,
      typeSelected
    );
  };

  issueSubmit = (doAdd) => {
    let requiredFieldData = [];
    if (
      hasValue(this.props.requiredFieldArray) &&
      this.props.requiredFieldArray.length > 0
    ) {
      for (let i = 0; i < this.props.requiredFieldArray.length; i++) {
        const array = this.props.requiredFieldArray[i];
        if (array !== null) {
          const fields = {
            ORI: this.state.ORI.value, //get any change to the ORI
            INCIDENTTYPE: this.state.INCIDENTTYPE.value,
            SECTIONNAME: array.SECTIONNAME.value,
            FIELDNAME: array.FIELDNAME.value,
            REQUIRE: array.REQUIRE.value,
          };
          requiredFieldData.push(fields);
        }
      }
    }
    if (doLog())
      console.log(
        "[ManageIncidentType] handleSubmitButton requiredFieldData:",
        requiredFieldData
      );

    const transactionType = "CitizenIncidentTypeWrite";
    const data = {
      incidentType: this.state.INCIDENTTYPE.value,
      ori: this.state.ORI.value,
      description: this.state.DESCRIPTION.value,
      definition: this.state.DEFINITION.value,
      examples: this.state.EXAMPLES.value,
      confirmingQuestion: this.state.CONFIRMINGQUESTION.value,
      requireNameInfo: this.state.REQUIRENAMEINFO.value,
      requirePropertyInfo: this.state.REQUIREPROPERTYINFO.value,
      requireVehicleInfo: this.state.REQUIREVEHICLEINFO.value,
      requireTowInfo: this.state.REQUIRETOWINFO.value,
      permissionName: this.state.PERMISSIONNAME.value,
      activeFlag: this.state.ACTIVEFLAG.value,
      //
      requiredFieldData: requiredFieldData,
    };
    const request = {
      transactionType,
      data,
    };

    if (doLog())
      console.log("[ManageIncidentType] issueSubmit request:", request);
    this.setState({ searching: true });
    this.props.onRunTransaction(request, this.props.token, "incidentTypeWrite");
  };

  loadGridRows = (array) => {
    if (doLog()) console.log("[ManageIncidentType] loadGridRows");
    const listRows = [];
    if (array !== null) {
      for (let i = 0; i < array.length; i++) {
        const fields = array[i];
        listRows.push({
          id: i,
          description: fields.DESCRIPTION,
          definition: fields.DEFINITION,
          examples: fields.EXAMPLES,
          typeCode: fields.INCIDENTTYPE,
        });
      }
    }
    const gridColumns = [
      {
        field: "description",
        renderHeader: (params) => <strong>{"Description"}</strong>,
        width: 300,
      },
      {
        field: "definition",
        renderHeader: (params) => <strong>{"Definition"}</strong>,
        width: 200,
        // flex: 2
      },
      {
        field: "examples",
        renderHeader: (params) => <strong>{"Examples"}</strong>,
        width: 200,
      },
      {
        field: "typeCode",
        renderHeader: (params) => <strong>{"Type Code"}</strong>,
        width: 100,
      },
    ];

    this.setState({
      selectIncidentType: updateObject(this.state.selectIncidentType, {
        gridDefaultRows: listRows,
        gridRows: listRows,
        gridColumns: gridColumns,
      }),
    });
  };

  render() {
    let activeSection = null;
    if (
      !this.state.searching &&
      hasValue(this.props.result !== null) &&
      hasValue(this.props.result.RESULT) &&
      hasValue(this.props.result.RESULT.CITIZENINCIDENTTYPE) &&
      this.props.transDesc === "incidentTypeList"
    ) {
      let addButtonSection = (
        <Grid item xs={12}>
          <Button
            variant="contained"
            //color="default"
            color="primary"
            size="small"
            onClick={this.handleAddButton.bind(this)}
          >
            Add Another
          </Button>
        </Grid>
      );
      if (this.state.actionEdit === true || this.state.actionAdd === true) {
        addButtonSection = (
          <Grid item xs={12}>
            {" "}
          </Grid>
        );
      }

      const optionSelect = (
        <Fragment>
          <Grid item xs={12}>
            {this.getFormField("selectIncidentType", false, true)}
          </Grid>
          {addButtonSection}
        </Fragment>
      );

      activeSection = <Fragment>{optionSelect}</Fragment>;
    }

    let informationSection = null;
    if (
      (this.state.actionEdit && hasValue(this.state.item)) ||
      this.state.actionAdd
    ) {
      let itemDescription = "";
      if (this.state.actionEdit && hasValue(this.state.item))
        itemDescription = this.state.item.DESCRIPTION;
      if (doLog())
        console.log("[ManageIncidentType]render item:", this.state.item);
      const editType = this.state.actionAdd ? "Add" : "Edit";
      informationSection = (
        <p className={classes.Information}>
          {editType} Incident Type: {itemDescription}
        </p>
      );
    }

    const requiredInfoSection = (
      <Fragment>
        <p>What information should be collected for this type of incident?</p>
        <Grid container item>
          <Grid item xs={12}>
            {this.getFormField("REQUIRENAMEINFO", false, true)}
          </Grid>
          <Grid item xs={12}>
            {this.getFormField("REQUIREVEHICLEINFO", false, true)}
          </Grid>
          <Grid item xs={12}>
            {this.getFormField("REQUIREPROPERTYINFO", false, true)}
          </Grid>
        </Grid>
      </Fragment>
    );

    const userTypeButtonsSelect = (
      <Fragment>
        <p>Who will submit this type of incident?</p>
        <RadioGroup
          value={this.state.REQUIRETOWINFO.value}
          onChange={this.handleUserTypeButtonsChange}
          row={true}
        >
          <FormControlLabel
            label="General Public (This will prompt for complainant contact information)"
            value="N"
            control={<Radio color="primary" />}
          />
          <FormControlLabel
            label="Towing Company (This will prompt for complainant contact information)"
            value="Y"
            control={<Radio color="primary" />}
          />
        </RadioGroup>
        {this.getFormField("PERMISSIONNAME", false, true)}
      </Fragment>
    );

    let formFields = null;
    if (
      this.state.searching !== true &&
      ((this.state.actionEdit === true &&
        hasValue(this.state.item) &&
        hasValue(this.props.requiredFieldList)) ||
        (this.state.actionAdd === true &&
          hasValue(this.props.defaultRequiredFieldList)))
    ) {
      formFields = (
        <Grid
          container
          item
          className={classes.Card + " " + classes.FormFields}
          spacing={gridSpacing}
        >
          {informationSection}
          <Grid item xs={12}>
            <hr />
          </Grid>
          <Grid item xs={4}>
            {this.getFormField("INCIDENTTYPE", false, true)}
          </Grid>
          <Grid item xs={8} />
          {/* <Grid item xs={4}>
            {this.getFormField("ORI", false, true)}
          </Grid>
          <Grid item xs={8} /> */}
          <Grid item xs={12}>
            {this.getFormField("DESCRIPTION", false, true)}
          </Grid>
          <Grid item xs={12}>
            {this.getFormField("DEFINITION", false, true)}
          </Grid>
          <Grid item xs={12}>
            {this.getFormField("EXAMPLES", false, true)}
          </Grid>
          {/* <Grid item xs={12}>
            {this.getFormField("CONFIRMINGQUESTION", false, true)}
          </Grid> */}
          <Grid item xs={6}>
            {requiredInfoSection}
          </Grid>
          <Grid item xs={6}>
            {userTypeButtonsSelect}
          </Grid>
          <Grid item xs={12}>
            <hr />
          </Grid>
          <Grid item xs={4}>
            {this.getFormField("ACTIVEFLAG", false, true)}
          </Grid>
          <ManageRequiredFields
            incidentType={
              this.state.actionAdd ? "" : this.state.item.INCIDENTTYPE
            }
            useDefaultList={this.state.actionAdd}
          />
          <Grid item xs={12}>
            <Button
              variant="contained"
              //color="default"
              color="primary"
              size="small"
              onClick={this.handleSubmitButton.bind(this)}
            >
              Submit
            </Button>
            &nbsp;&nbsp;
            <Button
              variant="contained"
              //color="default"
              color="primary"
              size="small"
              onClick={this.handleSubmitAddButton.bind(this)}
            >
              Submit/Add Another
            </Button>
            &nbsp;&nbsp;
            <Button
              variant="contained"
              //color="default"
              color="primary"
              size="small"
              onClick={this.handleDeleteButton.bind(this)}
            >
              Delete
            </Button>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <Button
              variant="contained"
              //color="default"
              color="primary"
              size="small"
              onClick={this.handleCancelButton.bind(this)}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      );
    }

    return (
      <Fragment>
        {activeSection}
        {formFields}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.trans.loading,
    error: state.trans.error,
    isAuthenticated: state.auth.token !== null,
    authRedirectPath: state.auth.authRedirectPath,
    //
    result: state.trans.result,
    transDesc: state.trans.transDesc,
    requiredFieldArray: state.trans.requiredFieldArray,
    requiredFieldList: state.trans.requiredFieldList,
    defaultRequiredFieldList: state.trans.defaultRequiredFieldList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onRunTransaction: (options, token, transDesc) =>
      dispatch(actions.runTransaction(options, token, transDesc)),
    onClearTransactionResult: () => dispatch(actions.clearTransactionResult()),
    onClearTransDesc: () => dispatch(actions.clearTransDesc()),
    onFetchRequiredFieldList: (ori, token, type) =>
      dispatch(actions.fetchRequiredFieldList(ori, token, type)),
    onFetchDefaultRequiredFieldList: (token) =>
      dispatch(actions.fetchDefaultRequiredFieldList(token)),
    onClearRequiredFieldList: () => dispatch(actions.clearRequiredFieldList()),
    onSetRequiredFieldArray: (requiredFieldArray) =>
      dispatch(actions.setRequiredFieldArray(requiredFieldArray)),
  };
};

// export default withStyles(styles)(
//   connect(mapStateToProps, mapDispatchToProps)(ManageIncidentType)
// );
export default connect(mapStateToProps, mapDispatchToProps)(ManageIncidentType);
